import api from '@/api'

/**
 * 合作案例
 */
export default {
  state: {
    total: 0,
    cases: []
  },

  mutations: {
    SET_CASES (state, { total = 0, productCases }) {
      state.total = total
      state.cases = productCases
    }
  },

  actions: {
    createCase ({ commit }, data) {
      return api.story.createCase(data)
    },

    deleteCase ({ commit }, data) {
      return api.story.deleteCase(data)
    },

    updateCase ({ commit }, data) {
      return api.story.updateCase(data)
    },

    getCases ({ commit }, data) {
      return api.story.getCases(data).then(response => {
        commit('SET_CASES', response.data)
        return response
      })
    },

    getCaseById ({ commit }, data) {
      return api.story.getCaseById(data)
    }

  }
}
